













































import { Component, PropSync } from 'vue-property-decorator';
import BaseFilter from "@/components/Filter/BaseFilter";
import {RestrictionFilterParams}  from "@/store/sms/restrictions/types";
import {SelectWings, ToggleWings} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import { SelectItem } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings}})
export default class OriginatorRestrictionsFilter extends BaseFilter<RestrictionFilterParams> {
  @PropSync('show') is_show!: boolean;
  @Getter("restrictionsList") restrictionsList: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getRestrictions") actionGetRestrictions!: (filter:RestrictionFilterParams) => Promise<void>;

  params = {transport: "SMS"};
  serviceProvidersList:  any = []

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  created() {
    this.filtered();
  }

  defaultFilter(): RestrictionFilterParams {
    return {
      service_provider: undefined,
      restriction: undefined
    }
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "The rule for restricting originators",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetRestrictions(this.filter);
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  getConditionText(value:string):string|undefined {
    return (<SelectItem[]>this.restrictionsList)
      .find((obj: SelectItem) => obj.value === value)?.text
  }
}
